module.exports = __webpack_public_path__ + "static/media/Screen Shot 2022-09-19 at 4_1663600351788.69806c39.13";